import { headerHeightLg, headerHeightMd, headerHeightSm } from '@/constants/layouts';
import { Flex, FlexProps } from '@cmpsr/components';
import { PropsWithChildren } from 'react';

export default function ContentContainerAuthPages({ children, ...props }: PropsWithChildren & FlexProps) {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent={{ base: 'space-between', lg: 'center' }}
      height={{
        base: `calc(100svh - ${headerHeightSm})`,
        md: `calc(100svh - ${headerHeightMd})`,
        lg: `calc(100svh - ${headerHeightLg})`,
      }}
      {...props}
    >
      {children}
    </Flex>
  );
}
